var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.activeBroadcasts.length > 0)?_c('div',[_c(_setup.BroadcastContainer,{attrs:{"options":{ broadcasts: _setup.activeBroadcasts }}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }